// mKonnekt (Dezi) operating-company codes → display labels.
//
// Every manufacturer discount mKonnekt returns carries an `opCompanyCode` naming the Altria
// subsidiary that funds it. The code is what gets reported; the label is only for people reading an
// order. Shared by the web register and the admin order screens so the two never drift.

export const MKONNEKT_OP_COMPANY_LABELS = Object.freeze({
  "1070": "USSTC",
  "0004": "PM-USA",
  "1077": "Helix",
  "2000": "JMC",
  "1082": "NJOY",
});

/**
 * Label for an `opCompanyCode`. An unknown non-blank code is shown as-is (better than hiding who
 * funded the discount); a blank code yields "".
 */
export function opCompanyLabel(code) {
  const c = String(code ?? "").trim();
  if (!c) return "";
  // A code that went through a numeric column loses its leading zeros ("0004" → "4").
  const padded = /^\d{1,3}$/.test(c) ? c.padStart(4, "0") : c;
  return MKONNEKT_OP_COMPANY_LABELS[c] || MKONNEKT_OP_COMPANY_LABELS[padded] || c;
}
